import React from "react";
import { getHeroProduct } from "../../utils/product";
import Image from "../image/Image";
import { getLookHeroImageUrl } from "../../utils/heroProductUtils";
import { StylingLookHeroImage as StylingLookHeroImageType } from "../../types/productTypes/stylingLookProduct";

export default function StylingLookHeroImage({
  look,
  additionalClasses,
}: StylingLookHeroImageType) {
  const heroProduct = getHeroProduct(look.products)[0] ?? look.products[0];

  if (!heroProduct) {
    return null;
  }

  return (
    <Image
      key={`styling-look-hero-${look.id}`}
      url={getLookHeroImageUrl({
        product: heroProduct,
        looksProducts: look.products,
      })}
      alternateText={heroProduct.name}
      type="carousel"
      width={640}
      additionalClasses={additionalClasses}
      loadingType="lazy"
      ariaHidden={false}
    />
  );
}
